import { COMPLIANCE_QUESTIONNAIRES } from "./complianceQuestionnaireRegistry";


const BESPOKE_TOOLS = [
  {
    code: "WA_AFH_068_FULL_EVACUATION_DRILL",
    label: "Emergency Evacuation Drills",
    description: "Plan drills and log conducted drill reports.",
    icon: "ti-flame",
    path: "/emergency-evacuation-drills",
    featureKey: "emergencyEvacuationDrills",
  },
  {
    code: "WA_AFH_075_HOT_WATER_TEMPERATURE",
    label: "Hot Water Temperature",
    description: "Log resident-accessible hot water temperature readings.",
    icon: "ti-thermometer",
    path: "/water-temperature-readings",
    featureKey: "waterTemperatureReadings",
  },
  {
    code: "WA_AFH_003_ANNUAL_LICENSE_FEE",
    label: "Annual License Fee",
    description: "Track per-bed license fee payment, proof, and renewal deadline.",
    icon: "ti-receipt",
    path: "/license-fee",
    featureKey: "annualLicenseFee",
  },
];

const QUESTIONNAIRE_TOOLS = Object.entries(COMPLIANCE_QUESTIONNAIRES).map(([code, config]) => ({
  code,
  label: config.label,
  description: config.description,
  icon: config.icon,
  path: `/compliance/questionnaires/${code}`,
  featureKey: "complianceDashboard", // all questionnaire policies share this gate
}));

export const COMPLIANCE_POLICY_TOOLS = [...BESPOKE_TOOLS, ...QUESTIONNAIRE_TOOLS];